import { createContext } from 'react';

import { ProductModeType } from './types';

export const ProductModeContext = createContext<ProductModeType>(
  'recommended_products'
);
